/** Homepage copy that is also published as structured data (FAQPage). */

export const HOME_AUDIENCES = [
  {
    title: "Study and research groups",
    copy: "Classmates and researchers who want each day of reading, writing or revision to leave a record the group can check.",
  },
  {
    title: "Founders and freelancers",
    copy: "People who work without a manager and want peers to see what was promised in the morning and delivered by the next day.",
  },
  {
    title: "Health and habit circles",
    copy: "Friends building a routine together, from training plans to daily practice, who prefer evidence over good intentions.",
  },
] as const;

export const HOME_FAQ = [
  {
    question: "What is Kaizen?",
    answer:
      "Kaizen is a goal-tracking and accountability app for small private groups. Each member declares what they will do today, attaches evidence of the work, and asks other members to verify it.",
  },
  {
    question: "Who can see my work?",
    answer:
      "Only active members of your group. Private milestones and their evidence are visible to you alone, and nothing in a group is public.",
  },
  {
    question: "What counts as evidence?",
    answer:
      "A photo, video, audio clip, document, link, GitHub link or a written note, attached to the day's commitment by noon the next day.",
  },
  {
    question: "How many people can join a group?",
    answer:
      "Up to fifteen. Owners and admins approve everyone who asks to join with the group's code.",
  },
  {
    question: "Does my group have to use fines?",
    answer:
      "No. Groups have no fines unless their owners add their own fine rules. Kaizen records amounts and decisions but never collects or holds money.",
  },
  {
    question: "Who can use Kaizen?",
    answer: "Kaizen is for adults aged 18 or older.",
  },
] as const;
